// extracted by mini-css-extract-plugin
export default {"textInput":"textinput_textInput__P57D4"};